import React,{useEffect,useContext} from 'react'
import {Link} from 'react-router-dom'
import PrefixContext from "../../context/PrefixContext.js";
import About from '../About/index.js'

function Index() {

    const PrefixContextData = useContext(PrefixContext);

    const hashScroller = () => {
        const hash = window.location.hash;
        if(hash !== '' && hash !== null){
            const id = hash.replace('#', '');
            document.getElementById(id).scrollIntoView()
        }
    }
    
    useEffect(() => {
        hashScroller();
    })

    return (<>
        <section id="intro" className="clearfix">
            <div className="container d-flex h-100">
                <div className="row w-100 justify-content-center align-self-center">
                    <div className="col-md-6 intro-info my-auto order-md-first order-last">
                        <h2>The Perfect Resume Builder For<br/> Your <span>Professional Career!</span></h2>
                        <div className="text-center d-md-inline-block">
                            <Link to="/signup" className="btn-primary scrollto">Register Now</Link>
                        </div>
                    </div>
                    <div className="col-md-6 intro-img order-md-last order-first">
                        <img src={PrefixContextData.cdnPrefixUrl+"dummy-resume_KmvgfedSqO.jpg"} alt="" className="img-fluid intro-img border border-white"/>
                    </div>
                </div>
            </div>
        </section>

        <About />

        </>)
}

export default Index
